const prefix = 'usage';

export const FIND_CURRENT = `${prefix}/FIND_CURRENT`;
